import { ShopRendererThemesApiClient } from '@fourthwall/services/dist/ShopRendererThemesApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useInstallThemeMutation = createMutationHook(
  ShopRendererThemesApiClient.installTheme,
  {
    mutationKey: ['installTheme'],
  },
)
